// eslint-disable-next-line no-shadow
enum UserType {
    Customer = 'Customer',
    ChannelPartner = 'ChannelPartner',
    Ops = 'Ops',
    LMS = 'LMS',
}

export default UserType;
